import { Button, List } from 'antd-mobile'
import React from 'react'
import PropTypes from 'prop-types'
import { YenSpan } from '../common/YenSpan'

const { Item } = List

const YenItem = ({ value, children = '　' }) => {
  return <Item extra={<YenSpan>{value}</YenSpan>}>
    {children}
  </Item>
}

const CountItemButton = props => <Button size={'small'} {...props} />

const CountItemExtra = ({ value, onAdd, onSubtract }) => {
  return <div className={'justify-end'}>
    <CountItemButton onClick={onSubtract}>-</CountItemButton>&emsp;
    {value}&emsp;
    <CountItemButton onClick={onAdd}>+</CountItemButton>
  </div>
}

class CountItem extends React.PureComponent {
  static defaultProps = {
    step: 1,
    min: 1
  }
  static propTypes = {
    defaultValue: PropTypes.number,
    max: PropTypes.number,
    min: PropTypes.number,
    value: PropTypes.number,
    step: PropTypes.number,
    onChange: PropTypes.func
  }

  static getDerivedStateFromProps (nextProps, state) {
    if (nextProps.value !== undefined && state.value !== nextProps.value) {
      const { value: _value, defaultValue } = nextProps
      return {
        controlled: _value !== undefined,
        value: _value || defaultValue || 0
      }
    }
    return null
  }

  state = {
    controlled: this.props.value !== undefined,
    value: this.props.value || this.props.defaultValue || 0
  }

  render () {
    const { children } = this.props
    const { value } = this.state
    return <Item extra={<CountItemExtra value={value} onAdd={this.add} onSubtract={this.subtract} />}>
      {children}
    </Item>
  }

  add = () => {
    const { value, controlled } = this.state
    const { step, onChange, max } = this.props
    if (max && max === value) return
    const newValue = value + step
    onChange && onChange(newValue)
    !controlled && this.setState({
      value: newValue
    })
  }

  subtract = () => {
    const { value, controlled } = this.state
    const { step, onChange, min } = this.props
    if (value > min) {
      const newValue = value - step
      onChange && onChange(newValue)
      !controlled && this.setState({
        value: newValue
      })
    }
  }

}

// todo remove
const ImagePlaceholder = ({ size = 150, color = '#e8e8e8', ...props }) => <div
  style={{ height: size, width: size, backgroundColor: color, margin: 'auto' }} {...props} />

// todo remove
class ImageItem extends React.PureComponent {
  static propTypes = {
    src: PropTypes.string
  }

  render () {
    const { src } = this.props
    return <Item>
      {
        (src)
          ? <img style={{ display: 'block', height: 'auto', margin: 'auto', width: '100%' }} src={src} alt={''} />
          : <ImagePlaceholder />
      }
    </Item>
  }
}

export { CountItem, ImageItem, YenItem }
